import * as React from 'react';
import { BoxProps } from '@kite-js/core/lib/Box/Box';
import { IconId } from '@drone-js/core';

export type Notification = {
    color: 'success' | 'info' | 'error';
    icon?: JSX.Element;
    message: string;
    link?: JSX.Element;
    testId?: string;
    container?: string;
    messeageJsx?: JSX.Element;
    forceInternal?: boolean;
    overrideIconId?: IconId;
    analyticsProps?: Record<string, any>;
};

export type NotificationContext = {
    notifications: Notification[];
    resetNotification: () => void;
    pushNotification: (notification: Notification) => void;
    renderNotification: (container: string, wrapperProps?: BoxProps) => React.ReactNode;
};

export const NotificationCenterContext = React.createContext<NotificationContext>({
    notifications: [],
    pushNotification: () => {},
    resetNotification: () => {},
    renderNotification: () => null,
});

NotificationCenterContext.displayName = 'NotificationCenterContext';
